import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, take } from 'rxjs';
import { AccessRestrictedDialogComponent } from '../access/access-dialog.component';
import { StubAccessService } from '../core/access/access.service';
import { Feature } from 'marketplace-ui';

@Injectable()
export class FeatureAccessService {
  private accessService = inject(StubAccessService);
  private dialog = inject(MatDialog);
  private dialogRef = inject(MatDialogRef<AccessRestrictedDialogComponent>);

  public hasAccessToFeature(feature: Feature): Observable<boolean> {
    return this.accessService.hasAccessToFeature(feature);
  }

  public openRestrictedDialog(featureId: string): void {
    this.dialog.closeAll();
    this.dialogRef = this.dialog.open(AccessRestrictedDialogComponent, {
      width: '710px', // same width used for the modal in the ManageAccountsComponent
      maxWidth: '90vw',
      data: { featureId: featureId },
    });

    this.dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => (this.dialogRef = null));
  }
}
